import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { ChangePasswordRoutingModule } from './change-password-routing.module';
import { ChangePasswordComponent } from './change-password.component';
import { SharedDirectivesModule } from '@app/@core/directives/shared-directives.module';

@NgModule({
  declarations: [ChangePasswordComponent],
  imports: [CommonModule, ChangePasswordRoutingModule, PrimengModule, ReactiveFormsModule,SharedDirectivesModule]
})
export class ChangePasswordModule {}
